<!-- Actions bar -->
<div class="flex flex-col lg:flex-row flex-wrap gap-3 items-center">
  <!-- @if(isPrimaryUser){
    <app-button
      [label]="'BUTTONS.ADD_USER' | translate"
      [classesName]="'card-edge-cut-white px-6 py-1'"
      (onBtnClick)="addUser()"
    ></app-button>
  } -->

  <div class="ltr:lg:ml-auto rtl:lg:mr-auto relative w-full lg:w-auto">
    <div class="flex items-center border border-gray-300 rounded overflow-hidden max-w-full lg:w-[320px]">
      <input
        #searchInput
        type="text"
        [placeholder]="'SEARCH' | translate"
        class="flex-grow px-4 py-2 text-sm focus:outline-none"
        (input)="handleSearch($event)"
        (keyup.enter)="handleSearch($event)"
      />
      <button type="button" class="px-4 text-dc-navy" (click)="handleSearch({ target: searchInput })">
        <i class="fas fa-search"></i>
      </button>
    </div>
  </div>
</div>

<!-- Board Members table -->
<div class="block mt-5">
  <table class="dc-table">
    <thead>      
      <th class="w-[20%] px-4 py-3">{{ "USERS.HEAD.NAME" | translate }}</th>
      <th class="w-[16%] px-4 py-3">{{ "USERS.HEAD.TYPE" | translate }}</th>
      <th class="w-[16%] px-4 py-3">{{ "USERS.HEAD.PHONE" | translate }}</th>
      <th class="w-[20%] px-4 py-3">{{ "USERS.HEAD.EMAIL" | translate }}</th>
      <th class="w-[12%] px-4 py-3">
        {{ "USERS.HEAD.ADMIN_USER" | translate }}
      </th>
      <th class="w-[16%] px-4 py-3 text-center!">
        {{ "ACTIONS" | translate }}
      </th>
    </thead>
    <tbody>
      <!-- skeleton -->
      @if (loader) {
        @for (_ of [].constructor(pageSize); track $index) {
          <tr class="divide-x divide-slate-300 border-b border-slate-200">
            @for (__ of [].constructor(6); track $index) {
              <td class="p-4 py-4!">
                <span
                  class="block h-3 w-full rounded bg-slate-200 animate-pulse"
                ></span>
              </td>
            }
          </tr>
        }
      } @else {
        @for (user of paginatedUsers; track $index) {
          <tr>
            <td class="truncate! py-4!">
              <span class="font-semibold truncate!">
                {{ user["DC Name English"] }}
              </span>
            </td>
            <td class="py-4!">{{ user.ContactXM ? user.ContactXM["DC User Type"] : "" }}</td>
            <td>{{ user["Work Phone #"] }}</td>
            <td>{{ user["Email Address"] }}</td>
            <td>
              {{(user["DC Admin Flag"] == "Y" ? 'OWNER_FORM.RESIDENCY_YES' : "OWNER_FORM.RESIDENCY_NO") | translate}}
            </td>
            <td class="lg:text-center!">
              <div class="flex gap-2 justify-center">
                <span
                  (click)="view(user)"
                  class="font-medium text-dc-dark-blue cursor-pointer underline underline-offset-4"
                  >{{ "BUTTONS.VIEW_DETAILS" | translate }}</span
                >
                @if (isPrimaryUser && !isSameUserAsLogin(user)) {
                  <span
                    (click)="remove(user)"
                    class="font-medium text-dc-dark-blue cursor-pointer underline underline-offset-4"
                    >{{ "BUTTONS.REMOVE" | translate }}</span
                  >
                }
              </div>
            </td>
          </tr>
        }
      }
      @if (!loader && (!filteredUsers || filteredUsers.length < 1)) {
        <tr>
          <td class="text-center! py-4 text-dc-gray-light italic" colspan="6">
            {{ "NO_RECORD_FOUND" | translate }}
          </td>
        </tr>
      }
    </tbody>
  </table>

  @if (!loader && totalPages > 1) {
    <div class="flex justify-center">
      <app-table-pagenation
        [currentPage]="currentPage"
        [totalPages]="totalPages"
        (prev)="prevPage()"
        (next)="nextPage()"
        (goToPage)="goToPage($event)"
      />
    </div>
  }
</div>
